// extracted by mini-css-extract-plugin
export default {"textContainerClass":"summary-subscribe-form_textContainerClass__8TH7w"};